import React from 'react';
import classNames from 'classnames';

import { InlineTextButton } from '../Button/Button';
import IconEye from '../IconEye/IconEye';

import css from './PasswordFieldWrapper.module.css';

const PasswordFieldWrapper = ({ className, children }) => {
  const [showPassword, setShowPassword] = React.useState(false);
  return (
    <div className={classNames(css.wrapper, className)}>
      {React.cloneElement(children, {
        type: showPassword ? 'text' : 'password',
      })}
      <InlineTextButton
        type="button"
        className={css.togglePasswordVisibility}
        onClick={() => setShowPassword(!showPassword)}
      >
        <IconEye visible={showPassword} />
      </InlineTextButton>
    </div>
  );
};

export default PasswordFieldWrapper;
